import { Component, OnInit } from '@angular/core';
import { GroupManagementService } from '../../service/group-management.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.css']
})
export class GroupListComponent implements OnInit {

  search: string = "";
  dataTable: any[] = null
  cols: any[];
  userDetails: any = null;
  message: string = '';
  msgs: Message[] = [];

  constructor(private dataService: GroupManagementService, private router: Router, private userService: UserService) { }

  ngOnInit() {

    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (this.userDetails) { // && (this.userDetails.ClientRoleAdministration)) {
        this.dataService.getGroupList().subscribe((result: any) => {
          this.dataTable = result
        }, (error: HttpErrorResponse) => { this.showMessage('error', '', error.statusText) });
      }
      else {
        this.showMessage('error', '', 'Access denied');
      }
    }, (err: HttpErrorResponse) => {
      this.userDetails = null;
      this.showMessage('error', '', 'Access denied');
    });

     this.cols = [
       // { field: 'GroupId', header: '' },
       { field: 'GroupName', header: 'שם קבוצה' },
       { field: 'isPrivate', header: 'פרטי' },
       { field: 'PrivateToUser', header: 'פרטי של משתמש' },
       { field: 'Active', header: 'פעיל' }
     ];
  }

  editGroup(GroupId) {
    this.router.navigate(['group-edit/', GroupId])
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/group-management/group-list/group-list.component.ts